/**
 * 페이지의 "main image"가 로드된 뒤 OG 이미지 메타를 해당 이미지로 덮어쓰기.
 * - 기본값은 `useMetaTags`에서 `ogimage.png`로 들어가지만,
 * - main image 컴포넌트가 존재하는 페이지는 여기서 교체합니다.
 */
export function setOgImage(image: string) {
  if (typeof window === 'undefined') return;
  const baseUrl = window.location.origin;

  const absUrl = (() => {
    if (!image) return '';
    if (/^https?:\/\//i.test(image)) return image;
    if (image.startsWith('/')) return `${baseUrl}${image}`;
    return image;
  })();

  if (!absUrl) return;

  const upsertMetaProperty = (property: string, content: string) => {
    const selector = `meta[property="${property}"]`;
    const existing = document.querySelector(selector) as HTMLMetaElement | null;
    if (existing) {
      existing.setAttribute('content', content);
      return;
    }
    const meta = document.createElement('meta');
    meta.setAttribute('property', property);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  };

  const upsertMetaName = (name: string, content: string) => {
    const selector = `meta[name="${name}"]`;
    const existing = document.querySelector(selector) as HTMLMetaElement | null;
    if (existing) {
      existing.setAttribute('content', content);
      return;
    }
    const meta = document.createElement('meta');
    meta.setAttribute('name', name);
    meta.setAttribute('content', content);
    document.head.appendChild(meta);
  };

  upsertMetaProperty('og:image', absUrl);
  upsertMetaProperty('og:image:secure_url', absUrl);
  upsertMetaName('twitter:image', absUrl);
}

